export default class SubscriptionTime {
  remainingHours: number;

  constructor(remainingTime: number) {
    this.remainingHours = remainingTime;
  }
}